import { Button } from "@/components/ui/button";
import { createPursuit } from "@/features/pursuit/api/apiPursuit";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Eye } from "lucide-react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export function useCreatePursuit(
  searchType,
  proposalId,
  isNavigateOnSuccess = false
) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPursuit,
    onSuccess: ({ pursuit_id }) => {
      queryClient.invalidateQueries(["user-pursuits"]);
      if (searchType && proposalId) {
        queryClient.invalidateQueries(["contract", searchType, proposalId]);
      }
      toast.success(() => (
        <div className="flex items-center gap-4">
          Journey created successfully.
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate(`/journey-hub/${pursuit_id}`)}
          >
            <Eye /> View
          </Button>
        </div>
      ));
      if (isNavigateOnSuccess) {
        navigate(`/journey-hub/${pursuit_id}/proposal`);
      }
    },
  });
}
